import { store } from "lib/redux/store";
import {setCurrentSection} from "lib/redux/settingsSlice";

type DataObject = {
  [key: string]: string;
};
export function getKeyByValue(obj: DataObject, value?: string): string | null {
  return Object.keys(obj).find((key) => obj[key] === value) || null;
}
export function handleClick(heading?: string): void {
  const {resume}= JSON.parse(localStorage.getItem("open-resume-state") as string);
  const sectionKey = getKeyByValue(resume.formToHeading, heading);
  if (sectionKey) {
    store.dispatch(setCurrentSection(sectionKey));
  }
}
